// Singleton to store the callback
let storedCallback = null;

export const setPopupCallback = callback => {
  storedCallback = callback;
};

export const getPopupCallback = () => {
  const callback = storedCallback;
  // Clear after getting
  storedCallback = null;
  return callback;
};
